export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

export type HourOfDay =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23

export type BaseSearchCriteria = {
  date?: {
    from: string
    to: string
  }
  pagination?: {
    offset?: number
    limit: number
    page?: number
  }
}

export type ExtendedSearchCriteria = BaseSearchCriteria & {
  type?: string
}

export enum OperationModels {
  FULL_SERVICE = 'FULL_SERVICE',
  PICK_AND_COLLECT = 'PICK_AND_COLLECT',
  PICK_AND_DELIVERY = 'PICK_AND_DELIVERY',
  PICK_AND_DELIVERY_WITH_STORAGE = 'PICK_AND_DELIVERY_WITH_STORAGE',
  PICK_AND_COLLECT_NO_TRANSFER = 'PICK_AND_COLLECT_NO_TRANSFER',
  PICK_AND_DELIVERY_WITH_STORAGE_NO_TRANSFER = 'PICK_AND_DELIVERY_WITH_STORAGE_NO_TRANSFER',
  ZONE_PICKING_AND_DELIVERY_WITH_STORAGE = 'ZONE_PICKING_AND_DELIVERY_WITH_STORAGE',
  ZONE_PICKING_AND_COLLECT = 'ZONE_PICKING_AND_COLLECT'
}
export type OperationModel = keyof typeof OperationModels

export enum VehicleIcon {
  BICYCLE = 'https://odin-images-and-files.s3.amazonaws.com/vehicle-icons/bicycle-blue.svg',
  DRONE = 'https://odin-images-and-files.s3.amazonaws.com/vehicle-icons/drone-blue.svg',
  MOTORCYCLE = 'https://odin-images-and-files.s3.amazonaws.com/vehicle-icons/motorcycle-blue.svg',
  SCOOTER = 'https://odin-images-and-files.s3.amazonaws.com/vehicle-icons/scooter-blue.svg',
  TRUCK = 'https://odin-images-and-files.s3.amazonaws.com/vehicle-icons/truck-blue.svg',
  VAN = 'https://odin-images-and-files.s3.amazonaws.com/vehicle-icons/van-blue.svg',
  CAR = 'https://odin-images-and-files.s3.amazonaws.com/vehicle-icons/car-blue.svg',
  WALK = 'https://odin-images-and-files.s3.amazonaws.com/vehicle-icons/walk-blue.svg'
}
